import type { StationSummary } from "../types";
import { GUIDE_CHANNEL } from "@serendiptv/contracts";
import { webcamForChannel, withWebcamStations } from "../webcams/catalog";

export { GUIDE_CHANNEL };
export type TunerStation = StationSummary & { kind: "broadcast" | "webcam" | "guide" };
export const GUIDE_STATION: TunerStation = {
  id: "service-tv-guide", channel: GUIDE_CHANNEL, call_sign: "CH 3", name: "TV Guide",
  identity: "Published listings, around the clock. All times Eastern.", kind: "guide"
};

export function tuningLineup(stations: StationSummary[]): TunerStation[] {
  return [...withWebcamStations(stations).filter((station) => station.channel !== GUIDE_CHANNEL)
    .map((station): TunerStation => ({ ...station, kind: webcamForChannel(station.channel) ? "webcam" : "broadcast" })), GUIDE_STATION]
    .sort((a, b) => a.channel - b.channel);
}
